import {cn} from '@ds/helpers';

type PinInfoRowProps = {
  title: React.ReactNode;
  value: React.ReactNode;
  hasBorder?: boolean;
};

const PinInfoRow: React.FC<PinInfoRowProps> = ({title, value, hasBorder = true}) => {
  return (
    <div
      className={cn(
        'flex min-h-11 items-center justify-between gap-3 px-2.5 py-2 text-body-sm',
        hasBorder && 'border-b border-gray-03'
      )}
    >
      <span className="text-gray-07">{title}</span>
      <span className="min-w-0 text-neutral-fg">{value}</span>
    </div>
  );
};

export default PinInfoRow;
